/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import to from 'to-case';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { ComponentWithInjectedProps } from 'utils/injectedProps';
import type { AvailableFilter, AvailableFilterOption } from 'tables/components/ReportView/types';

export type ListFilterProps = {
  filter: AvailableFilter,
  option: AvailableFilterOption,
  checked?: boolean,
  disabled?: boolean,
  onChange?: (newValue: boolean) => void,
  style?: any,
  key?: string,
};

type InjectedProps = TranslatorProps;

@translate()
@observer
export default class ListFilter extends ComponentWithInjectedProps<
  ListFilterProps,
  {},
  InjectedProps
> {
  render() {
    const { filter, option, checked, disabled, onChange, style, key, t } = this.props;
    let filterValueString: string;
    let labelTranslated: string = '';

    switch (filter.type) {
      case 'boolean':
        filterValueString = option.value ? t('general:disabled') : t('general:enabled');
        break;

      case 'string':
      default:
        filterValueString = String(option.label);
    }

    labelTranslated = filterValueString;

    if (filter.key === 'er_status' || filter.key === 'er_order_type') {
      labelTranslated = t('general:status.' + filterValueString.toLowerCase());
    }

    return (
      !!filterValueString && (
        <li style={style} key={key}>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={(e: SyntheticInputEvent<HTMLInputElement>, value: boolean) => {
                  if (onChange) {
                    onChange(value);
                  }
                }}
                disabled={disabled}
                disableRipple={true}
                value={filterValueString}
                color="primary"
              />
            }
            label={labelTranslated}
          />
        </li>
      )
    );
  }
}
